import React from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

const StatusConfirmation = (onConfirm) => {
  const [modal, contextHolder] = Modal.useModal();
  const intl = useIntl();

  const confirm = (val) => {
    modal.confirm({
      title: intl.formatMessage({
        id: "app.opportunities.change_to_irrelevant_title",
      }),
      icon: <ExclamationCircleOutlined />,
      content: intl.formatMessage({
        id: "app.opportunities.change_to_irrelevant_description",
      }),
      onOk() {
        return onConfirm(val);
      },
      onCancel() {},
    });
  };

  return { confirm, contextHolder };
};

export default StatusConfirmation;
